import RangeSlider from './RangeSlider';
import withLocale from '../IntlProvider/withLocale';
export default withLocale([])(RangeSlider);